/**
 * CRMDEV-7267: the booking search tabs poll `bookingWeeks` every 5 seconds with
 * `limit` set to every row scrolled in so far. A deep-scrolled tab therefore
 * asked the API to hydrate and map thousands of rows twelve times a minute,
 * which stalled the crm-api event loop for seconds at a time. Cap the polled
 * page instead.
 *
 * No row is lost: `GroupedVirtualSearchManager.merge` is a `uniqBy` union on
 * `_id`, so rows past the cap stay in the list — they simply stop refreshing
 * until the filter changes or they are scrolled in again.
 */
export const SEARCH_POLL_MAX_LIMIT = 200;

export const getPollLimit = (loadedItemCount?: number): number =>
  Math.min(loadedItemCount + 1 || 50, SEARCH_POLL_MAX_LIMIT);
